import * as React from 'react';
import { Route, Switch } from 'react-router';
import { ClubBookingsInbox } from './ClubBookingsInbox/ClubBookingsInbox';
import { ClubBookingArchive } from './ClubBookingArchive/ClubBookingArchive';
import { StudentPageHeader } from '../components/StudentPageHeader';
import '../components/StudentHub.scss';
import './ClubBookings.scss';
import '../../ParentView/components/ParentLists.scss';
import { ClubSectionCounts, clubSectionTabs, getStudentClubSectionCounts } from 'Src/helpers/club/clubSectionCounts';

export const ClubBookingsRouting = allProps => {
  const isPrevious = allProps.location.pathname.indexOf('/archive') !== -1;
  const isPast = isPrevious || allProps.location.pathname.indexOf('/history') !== -1;
  const [sectionCounts, setSectionCounts] = React.useState<ClubSectionCounts | undefined>();
  const refreshSectionCounts = React.useCallback(() => {
    return getStudentClubSectionCounts(allProps.user)
      .then(setSectionCounts)
      .catch(() => setSectionCounts(undefined));
  }, [allProps.user]);
  React.useEffect(() => {
    refreshSectionCounts();
  }, [refreshSectionCounts]);
  return (
    <main className="parentPage studentHubPage studentClubInvitesPage">
      <StudentPageHeader
        title="Clubs"
        tabs={clubSectionTabs(
          sectionCounts,
          isPrevious ? 'pastPrevious' : isPast ? 'pastCurrent' : 'invitations',
          allProps.history
        )}
      />
      <Switch>
        <Route
          exact
          path={'/clubBookings/inbox'}
          render={props => (
            <ClubBookingsInbox
              {...props}
              setNeedUpdate={allProps.setNeedUpdate}
              user={allProps.user}
              onSectionCountsChange={refreshSectionCounts}
            />
          )}
        />
        <Route
          exact
          path={'/clubBookings/history'}
          render={props => (
            <ClubBookingArchive
              {...props}
              user={allProps.user}
              mode="current"
              setNeedUpdate={allProps.setNeedUpdate}
              onSectionCountsChange={refreshSectionCounts}
            />
          )}
        />
        <Route
          exact
          path={'/clubBookings/archive'}
          render={props => (
            <ClubBookingArchive
              {...props}
              user={allProps.user}
              mode="previous"
              setNeedUpdate={allProps.setNeedUpdate}
              onSectionCountsChange={refreshSectionCounts}
            />
          )}
        />
      </Switch>
    </main>
  );
};

ClubBookingsRouting.displayName = 'ClubBookingsRouting';
